import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Chip,
  Grid,
  Link,
  Box,
  ImageList,
  ImageListItem,
  Dialog,
  DialogContent,
  IconButton,
  Tooltip,
} from '@mui/material';
import { blue } from '@mui/material/colors';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import DownloadIcon from "@mui/icons-material/Download";

import { useState } from 'react';

/* type StatusProps = {
  status: {
    title: string;
    tracking: any[];
    carrier: {
      name: string;
      trackingNumber: string;
      trackingUrl: string;
      trackingStatus: string | null;
      documents: { url: string; public_id: string }[];
    };
  };
  uid: string;
  dateCreated: string;
  dateExpires: string;
  createdAt: string;
  updatedAt: string;
}; */

export const StatusCard/* : React.FC<{ data: StatusProps }>  */= ({ data ,t,translateStatus}) => {
  const { carrier,title } = data;
  const [zoomedImage, setZoomedImage] = useState/* <string | null> */(null);
  const forceDownload = async(url, index) => {
   
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = `document-${index + 1}`; // change as needed
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl); // Clean up
  } catch (error) {
    console.error("Download failed:", error);
  }
}

  return (
    <div>
        {/* Zoom Image Lightbox */}
            {zoomedImage && (
              <Dialog open={true} onClose={() => setZoomedImage(null)} maxWidth="md">
                <DialogContent sx={{ textAlign: 'center' }}>
                  <img
                    src={zoomedImage}
                    alt="Zoomed"
                    style={{ maxWidth: '100%', maxHeight: '80vh', borderRadius: 12 }}
                  />
                </DialogContent>
              </Dialog>
            )}
    <Card variant="outlined" sx={{ borderRadius: 2, p: 0, mb: 3 }}>
      <CardContent>
       {/*  <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h6">{t("transactions.status")}</Typography>
          <Chip
            label={title}
            sx={{ backgroundColor: blue[100], color: blue[800], fontWeight: 600 }}
          />
        </Box> */}

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="text.secondary">{t("order.carriername")}</Typography>
            <Typography>{carrier.name}</Typography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="text.secondary">{t("order.carriertrackingnumber")}</Typography>
            <Typography>{carrier.trackingNumber}</Typography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="text.secondary">{t("order.carriertrackingurl")}</Typography>
            <Link href={`https://${carrier.trackingUrl}`} target="_blank" rel="noopener">
              {carrier.trackingUrl}
            </Link>
          </Grid>

         {/*  <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="text.secondary">Tracking Status</Typography>
            <Typography>{carrier.trackingStatus || '—'}</Typography>
          </Grid> */}
        </Grid>

        <Box mt={3}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Documents
          </Typography>
          <ImageList cols={3} rowHeight={140}>
            {carrier.documents.map((doc, i) => (
              <ImageListItem key={i}>
                <img
                  src={doc.url}
                  alt={`Document ${i + 1}`}
                  loading="lazy"
                  style={{ borderRadius: 8 }}
                  onClick={() => setZoomedImage(doc.url)}
                />
                  <IconButton
                                    size="small"
                                    sx={{
                                      position: 'absolute',
                                      top: 5,
                                      right: 5,
                                      backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                    }}
                                    onClick={() => setZoomedImage(doc.url)}
                                  >
                                    <ZoomInIcon />

                                  </IconButton>
                      <IconButton
                        onClick={() => {
                          forceDownload(doc.url,i);
                        }}
                        size="small"
                        sx={{
                          position: "absolute",
                          top: 8,
                          right: 8,
                          backgroundColor: "rgba(255,255,255,0.8)",
                          "&:hover": { backgroundColor: "white" },
                        }}
                      >
                        <DownloadIcon fontSize="small" />
                      </IconButton>
              </ImageListItem>
            ))}
          </ImageList>
        </Box>

        {/* <Box mt={3}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <Typography variant="subtitle2" color="text.secondary">UID</Typography>
              <Typography sx={{ wordBreak: 'break-all' }}>{title}</Typography>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography variant="subtitle2" color="text.secondary">Created At</Typography>
              <Typography>{new Date().toLocaleString()}</Typography>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography variant="subtitle2" color="text.secondary">Updated At</Typography>
              <Typography>{new Date().toLocaleString()}</Typography>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography variant="subtitle2" color="text.secondary">Date Created</Typography>
              <Typography>{new Date().toLocaleString()}</Typography>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography variant="subtitle2" color="text.secondary">Date Expires</Typography>
              <Typography>{new Date().toLocaleString()}</Typography>
            </Grid>
          </Grid>
        </Box> */}
      </CardContent>
       
    </Card></div>
  );
};
